import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useField, useForm } from 'react-final-form';
import { useIntl } from 'react-intl';

import Numbers from '@swf/components/Inputs/Numbers';
import StarsDropDown from '@swf/components/Inputs/StarsDropDown';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import { useIsMobileDevice } from '@swf/poker';

import BackIcon from '../../../assets/back.svg';
import CreateTournamentContext from '../../CreateTournamentContext/CreateTournamentContext';
import useSaveFormFields from '../../hooks/useSaveFormFields';
import Monthly from '../Monthly/Monthly';
import Range from '../Range/Range';
import Weekly from '../Weekly/Weekly';
import recurringOptions from '../utils/recurringOptions';

import {
  TXTCLI_Back,
  TXTCLI_Create_Tournament,
  TXTCLI_Done,
  TXTWCL_Edit_Recurrence,
  TXTWCL_Repeat_every
} from './Content.messages.json';
import styles from './Content.scss';

const Content = () => {
  const form = useForm();
  const { setState } = useContext(CreateTournamentContext);
  const { goPrevious } = useContext(NavigationContext);
  const isMobileDevice = useIsMobileDevice(true);
  const {
    input: { value }
  } = useField('recurringPatternType');
  const { formatMessage } = useIntl();

  const isDaily = value === 'HG_RECURRING_DAILY';
  const isWeekly = value === 'HG_RECURRING_WEEKLY';
  const isMonthly = value === 'HG_RECURRING_MONTHLY';
  const close = () => {
    setState((prevState) => ({ ...prevState, isRecurrenceOpen: false }));
    goPrevious();
  };
  useSaveFormFields();

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      title: formatMessage(TXTWCL_Edit_Recurrence),
      subTitle: ''
    }));

    return () =>
      setState((prevState) => ({
        ...prevState,
        title: isMobileDevice ? formatMessage(TXTCLI_Create_Tournament) : ''
      }));
  }, [formatMessage, setState, isMobileDevice]);

  return (
    <div className={styles.outer}>
      <div
        className={classNames(styles.container, {
          [styles.daily]: isDaily,
          [styles.weekly]: isWeekly,
          [styles.monthly]: isMonthly
        })}
      >
        <Numbers
          className={styles.input}
          label={TXTWCL_Repeat_every}
          min={1}
          id="repeatEvery"
          showValidationTick={false}
        />
        <StarsDropDown
          className={styles.dropdown}
          label="Recurring Pattern" // This label is hidden and used only for testing purposes
          hideLabel
          id="recurringPatternType"
          options={recurringOptions}
        />
        {isWeekly && <Weekly />}
        {isMonthly && <Monthly />}
        <Range />
      </div>
      <div className={styles.buttonContainer}>
        <StarsButton
          variant="text"
          className={classNames(styles.button, styles.back)}
          onClick={close}
          translation={TXTCLI_Back}
          icon={<BackIcon />}
        />
        <StarsButton
          className={styles.button}
          onClick={() => {
            form.change('repeat', true);
            // close interrupts form.change if not executed after the functions stack is finished.
            setTimeout(close, 0);
          }}
          translation={TXTCLI_Done}
        />
      </div>
    </div>
  );
};

export default Content;
